import { isHostInDomains, parseHttpUrl } from './urlValidation';

export type TextBlockLinkPlatform = 'Google Drive';

const GOOGLE_DRIVE_FILE_ID_REGEX = /^[a-zA-Z0-9_-]{10,}$/;

const isGoogleDriveFileUrl = (url: URL): boolean => {
  if (!isHostInDomains(url.hostname, ['drive.google.com'])) return false;
  if (url.pathname.includes('/folders/')) return false;

  const fileMatch = url.pathname.match(/^\/file\/d\/([^/]+)(?:\/|$)/);
  if (fileMatch && GOOGLE_DRIVE_FILE_ID_REGEX.test(fileMatch[1])) return true;

  if (url.pathname === '/open' || url.pathname === '/uc') {
    const id = url.searchParams.get('id');
    return !!id && GOOGLE_DRIVE_FILE_ID_REGEX.test(id);
  }

  return false;
};

export const parseSupportedTextBlockLinkUrl = (
  value: string,
): { url: URL; platform: TextBlockLinkPlatform } | null => {
  const url = parseHttpUrl(value);
  if (!url) return null;

  if (isGoogleDriveFileUrl(url)) {
    return { url, platform: 'Google Drive' };
  }

  return null;
};
